<template>
    <a :href="'tel:' + value">{{value}}</a>
</template>

<script>
export default {
    props: ['value'],
}
</script>
